import { UserDetail } from '../user/UserDetail';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParams } from 'react-router-dom';

function UserDetailWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();

    return <UserDetail guid={guid} user={user} />;
}

export default UserDetailWrapper;
